<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" v-show="showSearch" label-width="68px" @submit.prevent>
      <el-row>
        <el-col>
          <el-form-item prop="type">
            <el-radio-group v-model="queryParams.type" size="large" @change="selectType">
              <el-radio-button label="0">{{ $t('version.version0') }}</el-radio-button>
              <el-radio-button label="1">{{ $t('version.version1Tab') }}</el-radio-button>
              <el-radio-button label="2">{{ $t('version.version2') }}</el-radio-button>
              <el-radio-button label="3">{{ $t('version.version3') }}</el-radio-button>
            </el-radio-group>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item prop="name" style="width: 250px;">
        <el-input
          v-model="queryParams.name"
          :placeholder="$t('version.title') + $t('global.plsInput')"
          clearable
          v-ctrl-enter="handleQuery"
        />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="Search" @click="handleQuery">{{ $t('global.search') }}</el-button>
        <el-button icon="Refresh" @click="resetQuery">{{ $t('global.reset') }}</el-button>
      </el-form-item>
    </el-form>

    <el-row :gutter="10" class="mb8">
      <el-col :span="1.5">
        <el-button
          type="primary"
          plain
          icon="Plus"
          @click="handleAdd"
          v-hasPermi="['ep2:version:add']"
        >{{ $t('global.add') }}</el-button>
      </el-col>
      <!-- <el-col :span="1.5">
        <el-button
          type="success"
          plain
          icon="Edit"
          :disabled="single"
          @click="handleUpdate"
          v-hasPermi="['ep2:version:edit']"
        >{{ $t('global.edit') }}</el-button>
      </el-col> -->
      <el-col :span="1.5">
        <el-button
          type="danger"
          plain
          icon="Delete"
          :disabled="multiple"
          @click="handleDelete"
          v-hasPermi="['ep2:version:remove']"
        >{{ $t('global.delete') }}</el-button>
      </el-col>
      <el-col :span="1.5">
        <el-button
          type="warning"
          plain
          icon="Download"
          size="mini"
          @click="handleExport"
          v-hasPermi="['ep2:version:export']"
        >{{ $t('global.export') }}</el-button>
      </el-col>
      <!-- <right-toolbar v-model:showSearch="showSearch" @queryTable="getList"></right-toolbar> -->
    </el-row>

    <el-table ref="multipleTable" v-loading="loading" :data="versionList" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column :label="'ID'" prop="versionId"/>
      <CusTableColumn
        :label="!queryParams.type ? $t('version.name') : $t(`version.version${queryParams.type}`)"
        columnProp="name" />
        <el-table-column v-if="queryParams.type === '1'" :label="`Google${$t('version.name')}`" prop="googleName" width="160" />
      <!-- <el-table-column :label="$t('version.title') + $t('global.status')" align="center" prop="status">
        <template #default="scope">
           <dict-tag :options="sys_normal_disable" :value="scope.row.status" />
        </template>
      </el-table-column> -->
      <el-table-column :label="$t('global.createTime')" align="center" prop="createTime" min-width="180">
        <template #default="scope">
           <span>{{ parseTime(scope.row.createTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('global.updateTime')" align="center" prop="updateTime" min-width="180">
        <template #default="scope">
          <span>{{ parseTime(scope.row.updateTime) }}</span>
        </template>
      </el-table-column>
      <el-table-column :label="$t('global.operation')" align="center" class-name="small-padding fixed-width">
        <template #default="scope">
          <el-button
            link
            type="primary"
            icon="Edit"
            @click="handleUpdate(scope.row)"
            v-hasPermi="['ep2:version:edit']"
          >{{ $t('global.edit') }}</el-button>
          <el-button
            link
            type="primary"
            icon="Delete"
            @click="handleDelete(scope.row)"
            v-hasPermi="['ep2:version:remove']"
          >{{ $t('global.delete') }}</el-button>
        </template>
      </el-table-column>
    </el-table>

    <pagination
      v-show="total>0"
      :total="total"
      v-model:page="queryParams.pageNum"
      v-model:limit="queryParams.pageSize"
      @pagination="getList"
    />

    <!-- 添加或修改版本对话框 -->
    <el-dialog :title="title" v-model="open" width="500px" append-to-body :close-on-click-modal="false">
      <el-form ref="form" :model="form" :rules="rules" label-width="100px" @submit.prevent>
        <el-form-item :label="'ID'" prop="versionId">
          <el-input v-model="form.versionId" :placeholder="`ID${$t('global.plsInput')}`" />
        </el-form-item>
        <el-form-item :label="$t('version.name')" prop="name">
          <el-input v-model="form.name" :placeholder="$t('version.title') + $t('global.plsInput')" />
        </el-form-item>
        <el-form-item v-if="queryParams.type === '1'" :label="`Google${$t('version.name')}`" prop="googleName">
          <el-input v-model="form.googleName" :placeholder="`Google${$t('version.name')}` + $t('global.plsInput')" />
        </el-form-item>
        <!-- <el-form-item label="version Type" prop="type">
          <el-select v-model="form.type">
            <el-option
              v-for="(item, idx) in movie_version_type"
              :key="idx"
              :label="item.label"
              :value="item.value"
              ></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button type="primary" @click="submitForm">{{ $t('global.confirm') }}</el-button>
          <el-button @click="cancel">{{ $t('global.cancel') }}</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import {
  listVersion, getVersion, delVersion, addVersion, updateVersion,
} from '@/api/ep2/version';
import selectMixin from '@/utils/useSelect.js';

export default {
  name: 'Version',
  mixins: [selectMixin],
  data() {
    return {
      // 遮罩层
      loading: true,
      // 选中数组
      ids: [],
      // 非单个禁用
      single: true,
      // 非多个禁用
      multiple: true,
      // 显示搜索条件
      showSearch: true,
      // 总条数
      total: 0,
      // 版本表格数据
      versionList: [],
      // 弹出层标题
      title: '',
      // 是否显示弹出层
      open: false,
      // 查询参数
      queryParams: {
        pageNum: 1,
        pageSize: 50,
        type: '0',
        versionId: null,
        name: null,
        status: null,
      },
      // 表单参数
      form: {},
      // 表单校验
      rules: {
        // status: [
        //   { required: true, message: '角色状态不能为空', trigger: 'change' },
        // ],
        versionId: [
          { validator: this.$validateEmpty(`ID${this.$t('global.plsInput')}`, true), required: true, trigger: 'blur' },
        ],
        name: [
          { validator: this.$validateEmpty(this.$t('version.name') + this.$t('global.plsInput'), true), required: true, trigger: 'blur' },
        ],
        googleName: [
          { validator: this.$validateEmpty(`Google${this.$t('version.name')}${this.$t('global.plsInput')}`, true), required: true, trigger: 'blur' },
        ],

      },
      sys_normal_disable: null,
      movie_version_type: null,
    };
  },
  created() {
    this.sys_normal_disable = this.useDict('sys_normal_disable').sys_normal_disable;
    this.movie_version_type = this.useDict('movie_version_type').movie_version_type;
    this.getList();
  },
  methods: {
    // 选择version类别
    selectType() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 查询版本列表 */
    getList() {
      this.isSyncingSelection = true;
      this.loading = true;
      listVersion(this.queryParams).then((response) => {
        this.versionList = response.rows;
        this.total = response.total;
        this.loading = false;
        const _this = this;
        this.$nextTick(() => {
          _this.syncSelection(this.versionList);
          this.isSyncingSelection = false; // 重置标志
        });
      });
    },
    // 取消按钮
    cancel() {
      this.open = false;
      this.reset();
    },
    // 表单重置
    reset() {
      this.form = {
        id: null,
        type: null,
        versionId: null,
        name: null,
        status: null,
        createBy: null,
        createTime: null,
        updateBy: null,
        updateTime: null,
        delFlag: null,
      };
      this.resetForm('form');
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.queryParams.pageNum = 1;
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm('queryForm');
      this.handleQuery();
    },
    // 多选框选中数据
    handleSelectionChange(selection) {
      this.selectionChange(this.versionList, selection);
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset();
      this.open = true;
      this.title = this.$t('version.title') + this.$t('global.add');
    },
    /** 修改按钮操作 */
    handleUpdate(row) {
      this.reset();
      const id = row.id || this.ids;
      getVersion(id).then((response) => {
        this.form = response.data;
        this.open = true;
        this.title = this.$t('version.title') + this.$t('global.edit');
      });
    },
    /** 提交按钮 */
    submitForm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          if (this.form.id != null) {
            updateVersion(this.form).then(() => {
              this.$modal.msgSuccess(this.$t('global.editSuccess'));
              this.open = false;
              this.getList();
            });
          } else {
            addVersion({
              ...this.form,
              type: this.queryParams.type,
              status: '0',
            }).then(() => {
              this.$modal.msgSuccess(this.$t('global.addSuccess'));
              this.open = false;
              this.getList();
            });
          }
        }
      });
    },
    /** 删除按钮操作 */
    handleDelete(row) {
      const ids = row.id || this.ids;
      this.$modal.confirm(`${this.$t('global.confirmDelete')}${ids}？`).then(function () {
        return delVersion(ids);
      }).then(() => {
        this.getList();
        this.$modal.msgSuccess(this.$t('global.deleteSuccess'));
        this.ids = [];
        this.multiple = true;
      }).catch(() => {});
    },
    /** 导出按钮操作 */
    handleExport() {
      this.download('ep2/version/export', {
        ...this.queryParams,
      }, `version_${new Date().getTime()}.xlsx`);
    },
  },
};
</script>
